export const profile = {
    text1: "Informations de mon compte",
    text2: "Informations personnelles",
    text3: "Nom",
    text4: "Numéro de pièce d'identité",
    text5: "Téléphone",
    text6: "Pays",
    text7: "Adresse e-mail",
    text8: "Mettre à jour les informations",
    text9: "Données d'accès",
    text10: "Mot de passe",
    text11: "Confirmer le mot de passe",
    text12: "Mettre à jour le mot de passe",

    // Corrections
    p1: "Paramètres du compte",
    p2: "Données du profil",
    p3: "Connexion et sécurité",
    p4: "Informations de facturation",
    p5: "Adresse e-mail principale",
    p6: "C'est ici que vous recevrez toutes les communications de WACheckin",
    p7: "Informations du compte",
    p8: "Gérez les données de votre compte.",
    p9: "Nom",
    p10: "Saisissez le nom complet",
    p11: "Numéro de pièce d'identité",
    p12: "Saisissez le numéro de pièce d'identité",
    p13: "Téléphone",
    p14: "Saisissez le numéro de téléphone",
    p15: "Connexion et sécurité",
    p16: "Mettez à jour votre mot de passe et sécurisez votre compte.",
    p17: "Mot de passe du compte",
    p18: "Dernière mise à jour :",
    p19: "Changer le mot de passe",
    p20: "Informations de facturation",
    p21: "Gérez les données de votre compte.",
    p22: "Nom de l'entreprise",
    p23: "Saisissez le nom de l'entreprise",
    p24: "Identifiant fiscal",
    p25: "Saisissez l'identifiant fiscal",
    p26: "Adresse de facturation",
    p27: "Saisissez l'adresse de facturation",
    p28: "Pays",
    p29: "Province",
    p30:'Code postal',
    p31:`Aucune donnée de facturation`,
    p32:`Les informations de facturation sont ajoutées automatiquement lors de votre abonnement.`,
};